import { CategoryLangModelType } from '@teinor/erp/types/company/category/categoryLang'
import { useParams } from 'react-router'
import { CategoryModelType } from '@teinor/erp/types/company/category'
import { MediumModalCreateEdit, ModalCreateEditLoading } from '../../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { ModalEditComponentProps } from '../../../../../../../baseComponents/ModalsLayouts/types'
import { permissionCheck } from '../../../../../../../baseComponents/PermissionChecker/function'
import { FormRender } from '../../../../../../../forms/FormRenderer/types'
import { valueOrDefaultValue } from '../../../../../../../utils/globals/valueOrDefaultValue'
import { useBasicData } from '../../../../../../../utils/hooks/useBasicData'
import useLangData from '../../../../../../../utils/hooks/useLangData'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import { getActiveLangs } from '../../../../../../../utils/reducers/getters'
import { useCallback, useMemo, useState } from 'react'
import { addDictionaryExtraLine } from '../../../../../../../utils/globals/dictionary'
import { BeforeSubmitHandler } from '../../../../../../../forms/TwinForm/types'
import { SellVariablePayload } from '../../../../../../../utils/reducers/company/sellVariables'
import { connect, ConnectedProps } from 'react-redux'
import { AllReduxPayloads } from '../../../../../../../utils/reducers'
import withLoading from '../../../../../../../utils/hoc/withLoading'
import { ProductTypesPayload } from '../../../../../../../utils/reducers/products/productTypes'
import { CategoryAddonDict, CategoryAddonTy } from './types'
import useWasteWeightProduct from '../../../../../../../utils/hooks/product/useWasteWeightProduct'
import { parseCategoryAddonsBeforeSubmit } from './CategoryAddons/functions'
import CategoryAddons from './CategoryAddons'
import './modalCECategory.sass'
import useProductAddonTypeDict from '../../../../../../../utils/hooks/orders/useProductAddonTypeDict'
import { ProductAddonTypeTyInversed, ProductAddonTypeTyKeys } from '@teinor/erp/types/company/config/parameter'
import { RowData } from '../../../../../../../baseComponents/TwinTable/types'

type ModalCECategoryProps = ModalEditComponentProps & ReduxSellVariables &{ }

type ModifiedCategoryLangModelType = CategoryLangModelType & CategoryModelType & {
    categoryLangs: string
}
const ModalCECategory: React.FC<ModalCECategoryProps> = ({ userPermissions, allRowData, sellVariables, productTypes, ...rest }) => {
    const { CategoryId } = useParams()

    const { basicData } = useBasicData({ url: '/api/app/product/category/getCategoryInstance', params: { id: allRowData?.id }, doPetition: allRowData !== undefined})
    const { changeLang, selectedLang, data, changeValCurrentLang } = useLangData({ myData: basicData?.CategoryLangs, fieldsToLang: ['name'], keyValue: 'LangId' })
    const { t } = useTwinTranslation()
    const { categoryAddons, setCategoryAddons, beforeSubmit, typeCategoryAddon, setTypeCategoryAddon, productAddonType, handleChangeProductAddonType } = useModalCECategoryLogic({ allRowData })
    const dictProductTypes = useMemo(() => addDictionaryExtraLine(JSON.parse(JSON.stringify(productTypes || {}))), [productTypes])
    const { dictWasteWeightType } = useWasteWeightProduct({})
    const productAddonTypeDict = useProductAddonTypeDict()
    const memoProductAddonTypeDict = useMemo(() => addDictionaryExtraLine(JSON.parse(JSON.stringify(productAddonTypeDict))), [productAddonTypeDict])
    const fields: FormRender<ModifiedCategoryLangModelType> = [
        {
            cols: 2,
            elements: [
                {
                    name: 'LangId',
                    label: t('language', 'Idioma'),
                    component: 'CustomSelectWithSearchBar',
                    items: getActiveLangs(),
                    value: selectedLang,
                    onChange: changeLang
                },
                {
                    name: 'name',
                    label: t('name', 'Nombre'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    required: true,
                    lang: selectedLang,
                    value: data?.['name']?.[selectedLang] ?? '',
                    onChange: (name) => changeValCurrentLang('name', name)
                },
                {
                    name: 'ref_code',
                    label: t('code', 'Código'),
                    component: 'InputWithLabelMargin',
                    type: 'text'
                },
                {
                    name: 'ProductTypeId',
                    label: t('typeProduct', 'Tipo de producto'),
                    component: 'CustomSelectWithSearchBar',
                    items: dictProductTypes,
                    sortItems: true
                },
                {
                    label: t('wasteWeightType', 'Tipo de merma'),
                    name: 'wasteWeightType',
                    component: 'CustomSelectWithSearchBar',
                    items: dictWasteWeightType,
                    value: '0'
                },
                {
                    label: t('wasteWeight', 'Merma'),
                    name: 'wasteWeight',
                    component: 'InputNumberWithLabelMargin',
                    value: ''
                },
                {
                    name: 'productAddonType',
                    label: t('productAddonType', 'Tipo de complementos'),
                    component: 'CustomSelect',
                    items: memoProductAddonTypeDict,
                    sortItems: true, 
                    value: productAddonType || undefined,
                    onChange: (val) => handleChangeProductAddonType(val)
                },
                {
                    name: 'worksheetColor',
                    label: t('workSheetcolor', 'Color de hoja de trabajo'),
                    component: 'InputColorDeleteButtonWithMargin',
                    defaultValue: allRowData?.worksheetColor
                },
                {
                    name: 'categoryLangs',
                    component: 'InputHidden',
                    value: JSON.stringify(data?.name)
                },
                {
                    name: 'CategoryId',
                    component: 'InputHidden',
                    value: CategoryId
                },
                {
                    name: 'id',
                    component: 'InputHidden',
                    value: allRowData?.id
                }
            ]
        },
    ]
    if (allRowData && userPermissions) {
        const parsedFields = valueOrDefaultValue(fields, userPermissions, allRowData)
        return (
            <ModalCreateEditLoading fields={parsedFields} url={'/api/app/product/category/updateCategory'} translations={{ title: t('editCategory', 'Editar Categoría'), button: t('save', 'Guardar') }} beforeSubmit={beforeSubmit} haveButtonPermissions={permissionCheck(userPermissions, 'update')} {...rest} loading={data ? false : true} className='notFlexAutoFormRender'>
                <CategoryAddons CategoryId={allRowData?.id} {...{ productAddonType, userPermissions, categoryAddons, setCategoryAddons, typeCategoryAddon, setTypeCategoryAddon, sellVariables }} />
            </ModalCreateEditLoading>
        ) 
    }
    
    return (<MediumModalCreateEdit fields={fields} url={'/api/app/product/category/createCategory'} translations={{
        title: t('createCategory', 'Crear Categoría'),
        button: t('create', 'Crear')
    }} haveButtonPermissions={true} {...rest} />)
}

interface ModalCECategoryLogicProps {
    allRowData?: RowData
}

const useModalCECategoryLogic = ({ allRowData }: ModalCECategoryLogicProps) => {
    const [categoryAddons, setCategoryAddons] = useState<CategoryAddonDict | null>(null)
    const [typeCategoryAddon, setTypeCategoryAddon] = useState<CategoryAddonTy>(allRowData?.productAddonType === ProductAddonTypeTyInversed['buyAddons'] ? 1 : 0)
    const [productAddonType, setProductAddonType] = useState<ProductAddonTypeTyKeys | null>(allRowData?.productAddonType || null)

    const beforeSubmit: BeforeSubmitHandler = useCallback((vals) => {
        vals.categoryAddonsIds = JSON.stringify(categoryAddons?.idsSell || [])
        vals.categoryAddonsBuyIds = JSON.stringify(categoryAddons?.idsBuy || [])
        vals.categoryAddons = JSON.stringify(parseCategoryAddonsBeforeSubmit(categoryAddons?.dataSell))
        vals.categoryAddonsBuy = JSON.stringify(parseCategoryAddonsBeforeSubmit(categoryAddons?.dataBuy))
        return true
    }, [categoryAddons])

    const handleChangeProductAddonType = useCallback((val: string) => {
        setProductAddonType(parseInt(val) as ProductAddonTypeTyKeys)
        setTypeCategoryAddon(val === String(ProductAddonTypeTyInversed['buyAddons']) ? 1: 0)
    }, [setProductAddonType, setTypeCategoryAddon])

    return { categoryAddons, setCategoryAddons, beforeSubmit, typeCategoryAddon, setTypeCategoryAddon, productAddonType, handleChangeProductAddonType }
}

const sellVariablesDispatch = {
    setSellVariables: (payload: SellVariablePayload) => ({ type: 'CHANGE_SELLVARIABLE', payload }),
    setProductTypes: (payload: ProductTypesPayload) => ({ type: 'CHANGE_PRODUCT_TYPES', payload }),
}

export type ReduxSellVariables = ConnectedProps<typeof sellVariablesConnect>
const mapSellVariablesConnector = (state: AllReduxPayloads) => ({ sellVariables: state.sellVariables, productTypes: state.productTypes })
const sellVariablesConnect = connect(mapSellVariablesConnector, sellVariablesDispatch)
const sellVariablesConnectLoading = withLoading(ModalCECategory, [{ fetchUrl: '/api/app/config/sell/sellVariable/getAllSellVariables', propName: 'sellVariables', setFunctionName: 'setSellVariables' }, { fetchUrl: '/api/app/product/productType/getAllProductTypes', propName: 'productTypes', setFunctionName: 'setProductTypes' }])
const ModalCECategoryConnect = sellVariablesConnect(sellVariablesConnectLoading)
export default ModalCECategoryConnect